import { createI18n } from 'vue-i18n';
import ar from './locales/ar.json';
import en from './locales/en.json';

const messages = {
    ar,
    en,
};

const i18n = createI18n({
    locale: localStorage.getItem('language') || 'en', // Default to English
    fallbackLocale: 'en',
    messages,
});

export default i18n;